const breadcrumbs: Record<string, string | Record<string, string>> = {
    campaigns: 'Competitions',
    campaign: 'Competition',
    requests: 'Register of applications',
    requestsNew: 'Register of applications',
    campaignSettings: 'Competition settings',
};

export default breadcrumbs;